<template>

    <v-row style="width:100%;height:100%;" align="center" justify="center">
        <v-col>
            <v-expand-transition>
                <v-card
                        class="mx-auto my-auto"
                        max-width="450"
                        v-show="active"
                        height="380"
                >
                    <v-progress-linear color="red" :value="timeVis"></v-progress-linear>



                    <v-list-item class="mb-0" >
                        <v-list-item-subtitle style="text-align: center;" class="mx-auto">Sponsrat meddelande från</v-list-item-subtitle>
                    </v-list-item>


                    <v-row style="margin-top:-30px;">
                        <v-col>
                            <div id="sponsor_img" style="opacity:1;margin:0;color: white; background-image: url('/api/images/logo-utbildning_small.png'); height: 27px; width: 210px; background-color: transparent; background-size: cover;" class="mx-auto detail"></div>

                        </v-col>
                    </v-row>

                    <v-img
                            height="250"
                            src=""
                            v-if="compMode"

                    >
                        <img style="width: auto;position: absolute;" id="mainImage" src="/api/images/blocket_utb.png" class="move_bg"/>
                        <v-row style="margin-top:10px;" justify="space-around">
                            <v-avatar height="80" width="80">
                                <img
                                        :src=streamer_image

                                >
                            </v-avatar>
                        </v-row>
                        <v-list-item style="margin-top:-10px;" two-line>
                            <v-list-item-content style="text-align: center;">
                                <v-list-item-subtitle><p id="streamer_info" style="font-weight: bolder;font-size:1.4em;color:white;margin: 0;z-index: 3;"><b>{{name+name_end}}</b></p></v-list-item-subtitle>
                                <v-list-item-subtitle ><p style="font-size: 1.2em;color:white;">framtida <b>jobb</b></p><small style="color:white;">*enligt chatten</small></v-list-item-subtitle>
                            </v-list-item-content>
                        </v-list-item>
                        <v-row style="margin-top:-119px;">
                            <v-col class="py-0">
                                <v-list dense subheader>

                                    <v-list-item

                                    >

                                        <v-chip   class="ma-2" style="opacity:0.3;" text-color="white" color="red darken-4" small  v-if="votes0.length>2" > <b>{{votes0[votes0.length-3]}}</b> </v-chip>

                                    </v-list-item>
                                    <v-list-item

                                    >

                                        <v-chip   class="ma-2" style="opacity:0.6;" text-color="white" small color="red darken-4" v-if="votes0.length>1" > <b>{{votes0[votes0.length-2]}}</b> </v-chip>

                                    </v-list-item>
                                    <v-list-item

                                    >
                                        <v-chip  :class="showlatestVote0 ? 'shake_me':''" class="ma-2" text-color="white" color="red darken-4"  small v-if="votes0.length>0"> <b>{{votes0[votes0.length-1]}}</b> </v-chip>

                                    </v-list-item>
                                </v-list>
                            </v-col>
                            <v-col class="py-0">

                            </v-col>
                            <v-col style="text-align: right;" class="py-0">
                                <v-list dense subheader>

                                    <v-list-item
                                            style="text-align: right;"

                                    >
                                        <v-spacer></v-spacer>
                                        <v-chip class="ma-2" style="opacity:0.3;" text-color="white" color="red" small  v-if="votes1.length>2" > <b>{{votes1[votes1.length-3]}}</b> </v-chip>

                                    </v-list-item>
                                    <v-list-item

                                    >
                                        <v-spacer></v-spacer>
                                        <v-chip class="ma-2" style="opacity:0.6;" text-color="white" small color="red" v-if="votes1.length>1" > <b>{{votes1[votes1.length-2]}}</b> </v-chip>

                                    </v-list-item>
                                    <v-list-item

                                    >
                                        <v-spacer></v-spacer>
                                        <v-chip :class="showlatestVote1 ? 'shake_me':''"  class="ma-2" text-color="white" color="red"  small v-if="votes1.length>0"> <b>{{votes1[votes1.length-1]}}</b> </v-chip>

                                    </v-list-item>
                                </v-list>

                            </v-col>
                        </v-row>
                        <v-progress-linear
                                background-color="red"
                                color="red darken-4"
                                :value=ratio
                                height="60"
                                :stream=true
                        >
                            <template >
                                <v-chip
                                        class="ma-2"
                                        color="red darken-2"
                                        text-color="white"
                                        style="font-size: 16px;"
                                        v-if="option0!==null"

                                >
                                    <v-avatar
                                            left
                                            class="red darken-4"
                                    >
                                        !1
                                    </v-avatar>
                                    {{option0.title}}
                                </v-chip>
                                <v-spacer></v-spacer>
                                <span style="position: absolute;z-index: 4;"><b style="font-family: 'Bangers', cursive;font-size:30px;color:white;">VS</b></span>
                                <v-spacer></v-spacer>

                                <v-chip
                                        class="ma-2"
                                        color="red darken-2"
                                        text-color="white"
                                        style="font-size: 16px;"
                                        v-if="option1!==null"

                                >
                                    <v-avatar
                                            left
                                            class="red darken-4"
                                    >
                                        !2
                                    </v-avatar>
                                    {{option1.title}}
                                </v-chip>

                            </template>

                        </v-progress-linear>


                    </v-img>
                    <div v-if="!compMode && !isTie" style="height:250px;">

                        <v-img
                                height="200"
                                :src=winner_option.image


                        >
                            <v-row style="height:100%" justify="center" align="center">
                                <v-col>
                                    <v-card
                                            class="mx-auto"
                                            max-width="200"
                                            outlined
                                    >


                                        <v-list-item three-line>
                                            <v-list-item-content>
                                                <div style="margin-bottom: 0 !important;  margin-top: 0px;text-align: center;" class="overline mb-4"><b>🏆 {{winner_num_votes}} {{winner_num_votes===1?'röst':'röster'}} 🏆</b></div>

                                                <v-list-item-title style="text-align: center;" class="headline mb-1">{{winner_option.title}}</v-list-item-title>
                                                <div style="margin-bottom: 0 !important;  margin-top: 10px;" class="overline mb-4"><b>{{winner_option.school}}</b> <br> {{winner_option.category}}  </div>

                                            </v-list-item-content>


                                        </v-list-item>


                                    </v-card>
                                </v-col>
                            </v-row>

                        </v-img>

                        <v-row style="margin-top:-20px;" justify="center">
                            <v-col>
                                <v-card-subtitle style="text-align: center;"><span><b>{{winner_option.traits[0].header}}</b></span><br><span> {{winner_option.traits[0].value}}</span></v-card-subtitle>
                            </v-col>
                            <v-col>
                                <v-card-subtitle style="text-align: center;"><span><b>{{winner_option.traits[1].header}}</b></span><br><span> {{winner_option.traits[1].value}}</span></v-card-subtitle>
                            </v-col>
                            <v-col>
                                <v-card-subtitle style="text-align: center;"><span><b>{{winner_option.traits[2].header}}</b></span><br><span> {{winner_option.traits[2].value}}</span></v-card-subtitle>
                            </v-col>
                        </v-row>


                    </div>
                    <div v-if="!compMode && isTie" style="height:250px;">

                        <v-img
                                height="200"
                                src="/api/images/blocket_utb.png"


                        >
                            <v-row style="height:100%" justify="center" align="center">
                                <v-col>
                                    <v-card
                                            class="mx-auto"
                                            max-width="200"
                                            outlined
                                    >
                                        <v-card-text style="text-align: center;" class="overline">
                                            <b>{{this.votes0.length}} vs {{this.votes1.length}} <br>Det blev lika!</b>
                                        </v-card-text>
                                        <v-card-text style="text-align: center;" class="overline">
                                            Ibland kan det vara svårt att bestämma sig.
                                        </v-card-text>


                                    </v-card>
                                </v-col>
                            </v-row>

                        </v-img>

                        <v-row style="margin-top:-20px;" justify="center">

                        </v-row>


                    </div>



                    <v-card-subtitle v-if="compMode" style="text-align:center;font-size:15px;">🧙Rösta på !1 eller !2 i chatten!🌠</v-card-subtitle>
                    <v-card-subtitle v-if="!compMode && !isTie" style="text-align:center;font-size:15px;">Hitta din utbildning på <v-btn tile style="background:transparent;width:59px;height:13px;background-image: url('/api/images/blocket_white.png');background-size:cover;" depressed small></v-btn></v-card-subtitle>
                    <v-card-subtitle v-if="!compMode && isTie" style="text-align:center;font-size:15px;">Gör valet enklare med <v-btn tile style="background:transparent;width:59px;height:13px;background-image: url('/api/images/blocket_white.png');background-size:cover;" depressed small></v-btn> </v-card-subtitle>



                </v-card>
            </v-expand-transition>
        </v-col>

    </v-row>

</template>

<script>
    export default {
        name: "SponsComponent",
        data() {
            return {
                type:1,
                option0:null,
                option1:null,
                votes0:[],
                votes1:[],
                latestVote0:"",
                showlatestVote0:false,
                showlatestVote0Timer:null,
                latestVote1:"",
                showlatestVote1:false,
                showlatestVote1Timer:null,
                name:"",
                sid:"",
                timeVis:0,
                active:false,
                compMode:false,
                timeVisInterval:null,
                datajobs:[
                    {
                        title:"Animatör",
                        desc:"3D Animation & Visual Effects",
                        school:"Studin",
                        category:"Media & Kommunikation",
                        link:"https://utbildning.blocket.se/utbildningar/media-kommunikation/film-tv-radio-multimedia/3d-animation-visual-effects-vancouver-film-school-8220",
                        image:"https://utbildning.blocket.se/images/default-header-image.png",
                        traits:[
                            {header:"Studielängd",value:"1 år"},
                            {header:"CSN",value:"Ja✔️"},
                            {header:"Plats",value:"Kanada"}
                        ]
                    },
                    {
                        title:"Robottekniker",
                        desc:"Automation och Robotingenjör",
                        school:"Yrkeshögskolan Jönköping",
                        category:"Teknik & Ingenjör",
                        link:"https://utbildning.blocket.se/utbildningar/teknik-ingenjor/ingenjor/automation-och-robotingenjor-400-yhp-7507",
                        image:"https://blocket-utbildning-media-prod.s3.amazonaws.com/header_images/schools/806/headerimage_6959_nfh.jpg",
                        traits:[
                            {header:"Studielängd",value:"2 år"},
                            {header:"CSN",value:"Ja✔️"},
                            {header:"Studietakt",value:"Heltid"}
                        ]
                    },
                    {
                        title:"Designtekniker",
                        desc:"Designteknik - Surface Designer",
                        school:"YRGO",
                        category:"Teknik & Ingenjör",
                        link:"https://utbildning.blocket.se/utbildningar/teknik-ingenjor/ovrigt/designteknik-surface-designer-415-yh-poang-6742",
                        image:"https://blocket-utbildning-media-prod.s3.amazonaws.com/header_images/schools/633/yrgo-header.jpg",
                        traits:[
                            {header:"Studielängd",value:"2 år"},
                            {header:"CSN",value:"Ja✔️"},
                            {header:"Studietakt",value:"Heltid"}
                        ]
                    },
                    {
                        title:"Speldesigner",
                        desc:"Game & UX Designer",
                        school:"Changemaker Educations",
                        category:"Data & IT",
                        link:"https://utbildning.blocket.se/utbildningar/data-it/ovrigt/game-and-ux-designer-10819",
                        image:"https://utbildning.blocket.se/images/default-header-image.png",
                        traits:[
                            {header:"Studielängd",value:"1 år"},
                            {header:"CSN",value:"Ja✔️"},
                            {header:"Studietakt",value:"Heltid"}
                        ]
                    },
                    {
                        title:"VFX-artist",
                        desc:"VFX-artist",
                        school:"Xenter Botkyrka",
                        category:"Kultur & Design",
                        link:"https://utbildning.blocket.se/utbildningar/media-kommunikation/vfx-artist-7683",
                        image:"https://blocket-utbildning-media-prod.s3.amazonaws.com/header_images/schools/715/xenter-header.jpg",
                        traits:[
                            {header:"Studielängd",value:"2 år"},
                            {header:"CSN",value:"Ja✔️"},
                            {header:"Studietakt",value:"Heltid"}
                        ]
                    }],
                busjobs:[
                    {
                        title:"Projektledare",
                        desc:"Agil Projektledare",
                        school:"IHM Business School",
                        category:"Organisation & Ledning",
                        link:"https://utbildning.blocket.se/utbildningar/organisation-ledning/projektledare/agil-projektledare-distans-210-yh-poang-7799",
                        image:"https://blocket-utbildning-media-prod.s3.amazonaws.com/header_images/schools/634/headerimage_3836_nbx.jpg",
                        traits:[
                            {header:"Studielängd",value:"1 år"},
                            {header:"CSN",value:"Ja✔️"},
                            {header:"Studietakt",value:"Deltid"}
                        ]
                    },
                    {
                        title:"Reklamare",
                        desc:"Digital Conversion Manager",
                        school:"Sälj & Marknadshögskolan i Sverige",
                        category:"Bank, Finans & Försäkring",
                        link:"https://utbildning.blocket.se/utbildningar/bank-finans-forsakring/analys-radgivning/digital-conversion-manager-10606",
                        image:"https://blocket-utbildning-media-prod.s3.amazonaws.com/header_images/educations/10606/SMH-DigitalConversionManager.jpg",
                        traits:[
                            {header:"Studielängd",value:"1.5 år"},
                            {header:"CSN",value:"Ja✔️"},
                            {header:"Studietakt",value:"Deltid"}
                        ]
                    },
                    {
                        title:"Bussförare",
                        desc:"Bli bussförare hos Arriva!",
                        school:"Arriva Sverige AB",
                        category:"Transport & Logistik",
                        link:"https://utbildning.blocket.se/utbildningar/transport-logistik/chauffor/bli-bussforare-hos-arriva-10373",
                        image:"https://blocket-utbildning-media-prod.s3.amazonaws.com/header_images/schools/958/arriva-header.jpg",
                        traits:[
                            {header:"Studielängd",value:"3 månader"},
                            {header:"Start",value:"5 augusti 2020"},
                            {header:"Studietakt",value:"Heltid"}
                        ]
                    },

                    {
                        title:"Hundinstruktör",
                        desc:"Certifierad hundinstruktör",
                        school:"Hundens Hus",
                        category:"Miljö & Djurvård",
                        link:"https://utbildning.blocket.se/utbildningar/miljo-djurvard/djurvard/certifierad-hundinstruktor-7448",
                        image:"https://blocket-utbildning-media-prod.s3.amazonaws.com/header_images/schools/911/headerimage_7227_mdc.jpg",
                        traits:[
                            {header:"Utbildningstyp",value:"Yrkesutbildning"},
                            {header:"Start",value:"Löpande starter"},
                            {header:"Studietakt",value:"Deltid"}
                        ]
                    },
                    {
                        title:"Sekreterare",
                        desc:"Medicinsk sekreterare",
                        school:"YRGO",
                        category:"Administration",
                        link:"https://utbildning.blocket.se/utbildningar/medicinsk-sekreterare-400-yh-poang-6983",
                        image:"https://blocket-utbildning-media-prod.s3.amazonaws.com/header_images/schools/633/yrgo-header.jpg",
                        traits:[
                            {header:"Studielängd",value:"2 år"},
                            {header:"CSN",value:"Ja✔️"},
                            {header:"Studietakt",value:"Heltid"}
                        ]
                    }


                ],
                gamejobs:[
                    {
                        title:"Utvecklare",
                        desc:"Internet of Things-utvecklare",
                        school:"Nackademin",
                        category:"Data & IT",
                        link:"https://utbildning.blocket.se/utbildningar/data-it/internet-of-things-utvecklare-9358",
                        image:"https://blocket-utbildning-media-prod.s3.amazonaws.com/header_images/schools/676/headerimage_3918_olx.jpg",
                        traits:[
                            {header:"Studielängd",value:"2 år"},
                            {header:"CSN",value:"Ja✔️"},
                            {header:"Studietakt",value:"Heltid"}
                        ]
                    },
                    {
                        title:"Javautvecklare",
                        desc:"Javautvecklare",
                        school:"EC Utbildning",
                        category:"Data & IT",
                        link:"https://utbildning.blocket.se/utbildningar/data-it/javautvecklare-10598",
                        image:"https://blocket-utbildning-media-prod.s3.amazonaws.com/header_images/educations/10598/ec-java-utvecklare.jpg",
                        traits:[
                            {header:"Studielängd",value:"2 år"},
                            {header:"CSN",value:"Ja✔️"},
                            {header:"Studietakt",value:"Heltid"}
                        ]
                    },
                    {
                        title:"Spelgrafiker",
                        desc:"Spelgrafiker",
                        school:"TGA Utbildning",
                        category:"Data & IT",
                        link:"https://utbildning.blocket.se/utbildningar/data-it/spelgrafiker-9969",
                        image:"https://blocket-utbildning-media-prod.s3.amazonaws.com/header_images/schools/717/TGA-header.jpg",
                        traits:[
                            {header:"Studielängd",value:"2.5 år"},
                            {header:"CSN",value:"Ja✔️"},
                            {header:"Studietakt",value:"Heltid"}
                        ]
                    },
                    {
                        title:"Webbutvecklare",
                        desc:"Frontend Developer",
                        school:"Handelsakademin",
                        category:"Data & IT",
                        link:"https://utbildning.blocket.se/utbildningar/data-it/frontend-developer-10273",
                        image:"https://blocket-utbildning-media-prod.s3.amazonaws.com/header_images/educations/10273/FRONTEND.jpg",
                        traits:[
                            {header:"Studielängd",value:"2 år"},
                            {header:"CSN",value:"Ja✔️"},
                            {header:"Studietakt",value:"Heltid"}
                        ]
                    },
                    {
                        title:"Spelanimatör",
                        desc:"Spelanimatör",
                        school:"TGA Utbildning",
                        category:"Data & IT",
                        link:"https://utbildning.blocket.se/utbildningar/data-it/spelanimator-10611",
                        image:"https://blocket-utbildning-media-prod.s3.amazonaws.com/header_images/schools/717/TGA-header.jpg",
                        traits:[
                            {header:"Studielängd",value:"2.5 år"},
                            {header:"CSN",value:"Ja✔️"},
                            {header:"Studietakt",value:"Heltid"}
                        ]
                    },
                    {
                        title:"Spelprogrammerare",
                        desc:"Spelprogrammering",
                        school:"BTH - Blekinge tekniska högskola",
                        category:"Data & IT",
                        link:"https://utbildning.blocket.se/utbildningar/data-it/spelprogrammering-9815",
                        image:"https://blocket-utbildning-media-prod.s3.amazonaws.com/header_images/schools/702/headerimage_4604_ciq.jpg",
                        traits:[
                            {header:"Studielängd",value:"3 år"},
                            {header:"CSN",value:"Ja✔️"},
                            {header:"Studietakt",value:"Heltid"}
                        ]
                    }
                ]
            }
        },
        mounted:function(){
            this.show();
            this.connected();


        },

        computed: {
            ratio:function(){
                if(this.votes0.length===0 && this.votes1.length===0){
                    return 50
                }
                else if(this.votes0.length===0 && this.votes1.length!==0){
                    return 0
                }
                else if(this.votes0.length!==0 && this.votes1.length===0){
                    return 100
                }
                else{
                    return (this.votes0.length/(this.votes0.length+this.votes1.length)*100)
                }
            },
            streamer_image:function(){
                return `/api/images/users/${this.sid}.png`
            },
            name_end:function(){
                if(this.name.length>1 && this.name.slice(-1)!=="s"){
                    return "s"
                }
                else{
                    return ""
                }
            },
            winner_option:function(){
                //return this.datajobs[0];

                if(this.votes0.length>this.votes1.length){
                    return this.option0
                }
                else if(this.votes0.length<this.votes1.length){
                    return this.option1
                }
                else{
                    return {
                        title:"",
                        category:"",

                    }
                }
            },
            winner_num_votes:function(){
                if(this.votes0.length>this.votes1.length){
                    return this.votes0.length
                }
                else if(this.votes0.length<this.votes1.length){
                    return this.votes1.length
                }
                else {
                    return this.votes0.length
                }
            },
            isTie:function(){
                return this.votes0.length===this.votes1.length;
            }
        },


        methods:{

            vote:function(vote){
                if(!this.votes0.includes(vote[0]) && !this.votes1.includes(vote[0])){
                    if(vote[1]==="!1"){
                        this.vote0(vote[0]);
                    }
                    else if(vote[1]==="!2"){
                        this.vote1(vote[0]);
                    }
                }

            },


            connected:function(){

                this.name="Guthen";
                this.sid="79";
                let self=this;
                this.active=true;
                //let audio = new Audio('/api/sounds/card_alert1.mp3');
                //audio.volume=0.5;
                //audio.play();
                this.timeVisInterval=setInterval(function(){
                    self.timeVis+=1;
                },600);
                setTimeout(function(){
                    clearInterval(self.timeVisInterval);
                    self.compMode=false;


                },60000);

                setTimeout(function(){
                    self.generate_fake_votes();
                },3000)
                //this.generate_fake_votes();
            },
            vote0:function(voter){
                clearTimeout(this.showlatestVote0Timer);
                this.latestVote0=voter;
                this.showlatestVote0=true;
                let self=this;
                this.votes0.push(voter);
                this.$emit("vote",["1",voter]);
                this.showlatestVote0Timer=setTimeout(function(){
                    self.showlatestVote0=false;
                },1000)
            },
            vote1:function(voter){
                clearTimeout(this.showlatestVote0Timer);
                this.latestVote1=voter;
                this.showlatestVote1=true;
                let self=this;
                this.votes1.push(voter);
                this.$emit("vote",["2",voter]);

                this.showlatestVote1Timer=setTimeout(function(){
                    self.showlatestVote1=false;
                },1000)
            },
            generate_fake_votes:function(){
                let fake_names=[
                    "2cuteilla",
                    "Actuallynner",
                    "Americast",
                    "AmyKrool",
                    "Artuggle",
                    "Asedayal",
                    "Barqualin",
                    "Bazartip",
                    "Blondeange",
                    "Boardfi",
                    "Boardintech",
                    "Calcite",
                    "Candyes",
                    "Cattapp",
                    "ChickEssence",
                    "Comfylk",
                    "Confire",
                    "Coniervo",
                    "Contreelo",
                    "Cottonor",
                    "Cyberlo",
                    "Desightit",
                    "Dictatorma",
                    "DiddyParis",
                    "Disseri",
                    "Exterolo",
                    "Fabrium",
                    "Fareo",
                    "FelineFaith",
                    "Flexisys",
                    "FluentGrabs",
                    "Fraserstru",
                    "FullyWet",
                    "GazetteExclusive",
                    "Givelz",
                    "GrimSun",
                    "GrimWitch",
                    "Gurlyco",
                    "HeadDev",
                    "HeheMoto",
                    "HeheRob",
                    "Hipbb",
                    "Huningst",
                    "InfernoKix",
                    "Integar",
                    "Islandella",
                    "JimMj",
                    "JoFinest",
                    "KenkaMega",
                    "Laoandr",
                    "LeonHead",
                    "Listin",
                    "Losimuni",
                    "Lummobe",
                    "Mcanardua",
                    "Mcel",
                    "Midnighter",
                    "MinyTinnys",
                    "Mohawkey",
                    "NessNaybor",
                    "NoticeSaiyan",
                    "NycBleak",
                    "Papass",
                    "Pellinkie",
                    "PerfectHippo",
                    "Persdant",
                    "Phiard",
                    "PiraAsta",
                    "Racer2cool",
                    "RadioThesoy",
                    "Relysi",
                    "RocketSister",
                    "Ryothus",
                    "Sablinkak",
                    "Sageolag",
                    "Sanlc",
                    "Scirraybo",
                    "SelfCuddly",
                    "Senaouder",
                    "SereneKeepup",
                    "SkierSnoop",
                    "Sonflina",
                    "Spiceelli",
                    "Spicernin",
                    "Sublega",
                    "TalentCharms",
                    "TalesStylish",
                    "TaruRocker",
                    "Theevilla",
                    "TigerMusic",
                    "ToyFlavored",
                    "TrendyShoes",
                    "TrustQuayle",
                    "Ttiendos",
                    "Twiter",
                    "Tyob",
                    "V2co",
                    "Vamim",
                    "Venabba",
                    "Verterma"
                ];
                let name=fake_names[Math.floor(Math.random()*fake_names.length)]
                var vote0 = Math.random() >= 0.5;
                if(vote0){
                    this.vote0(name);
                }
                else{
                    this.vote1(name);
                }
                let self=this;

                setTimeout(function(){
                    if(self.compMode){
                        self.generate_fake_votes();
                    }
                },1000)
            },
            show:function(){
                this.resetAll();

                let random_list_arr=["data","bus","game"];
                let shuffled_list=random_list_arr.sort(() => Math.random() - Math.random()).slice(0, 2);
                let job_dict={"data": this.datajobs,"bus":this.busjobs,"game":this.gamejobs};
                let list1=job_dict[shuffled_list[0]];
                let list2=job_dict[shuffled_list[1]];
                this.option0= list1[Math.floor(Math.random() * list1.length)];
                this.option1= list2[Math.floor(Math.random() * list2.length)];


            },
            yell:function(){
                let id=this.$route.query.id;
                this.$socket.emit('yell_spons', [id]);


            },
            resetAll:function(){
                this.votes0=[];
                this.votes1=[];
                this.latestVote0="";
                this.showlatestVote0=false;
                this.showlatestVote0Timer=null;
                this.latestVote1="";
                this.showlatestVote1=false;
                this.showlatestVote1Timer=null;
                this.timeVis=0;
                this.compMode=true;
                this.active=false;
            }

        }
    }
</script>

<style>
    iframe{
        width:100% !important;
        height:100% !important;
    }
    ::-webkit-scrollbar {
        width: 0 !important;
    }

    /* Track */
    ::-webkit-scrollbar-track {
        background: transparent !important;
    }

    /* Handle */
    ::-webkit-scrollbar-thumb {
        background: transparent !important;
    }

    /* Handle on hover */
    ::-webkit-scrollbar-thumb:hover {
        background:transparent !important;
    }
    @keyframes MOVE-BG {

        from {
            -webkit-transform: translateX(-200px);
            -moz-transform: translateX(-200px);
            -ms-transform: translateX(-200px);
            -o-transform: translateX(-200px);
            transform: translateX(-200px);

        }
        to {

            -webkit-transform: translateX(-350px);
            -moz-transform: translateX(-350px);
            -ms-transform: translateX(-350px);
            -o-transform: translateX(-350px);
            transform: translateX(-350px);

        }
    }
    .move_bg{
        animation-name: MOVE-BG;
        animation-duration: 30s;
        animation-timing-function: ease-in-out;
        animation-iteration-count: 1;
        -webkit-animation-fill-mode: forwards;
    }

    .hidden {
        visibility: hidden;
        opacity: 0;
        transition: visibility 0s 2s, opacity 2s linear;
    }
    .visible {
        visibility: visible;
        opacity: 1;
    }

    .shake_me{
        animation: shake 0.3s;
    }

    @keyframes shake {
        0% { transform: translate(1px, 1px) rotate(0deg); }
        10% { transform: translate(-1px, -2px) rotate(-1deg); }
        20% { transform: translate(-3px, 0px) rotate(1deg); }
        30% { transform: translate(3px, 2px) rotate(0deg); }
        40% { transform: translate(1px, -1px) rotate(1deg); }
        50% { transform: translate(-1px, 2px) rotate(-1deg); }
        60% { transform: translate(-3px, 1px) rotate(0deg); }
        70% { transform: translate(3px, 1px) rotate(-1deg); }
        80% { transform: translate(-1px, -1px) rotate(1deg); }
        90% { transform: translate(1px, 2px) rotate(0deg); }
        100% { transform: translate(1px, -2px) rotate(-1deg); }
    }

</style>
